import { render, staticRenderFns } from "./ValidateNumberForm.vue?vue&type=template&id=3b1736e6&scoped=true"
import script from "./ValidateNumberForm.vue?vue&type=script&lang=js"
export * from "./ValidateNumberForm.vue?vue&type=script&lang=js"
import style0 from "./ValidateNumberForm.vue?vue&type=style&index=0&id=3b1736e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1736e6",
  null
  
)

/* custom blocks */
import block0 from "./ValidateNumberForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports